import { render, staticRenderFns } from "./OutreachApproveforNicheView.vue?vue&type=template&id=60b9db74&"
import script from "./OutreachApproveforNicheView.vue?vue&type=script&lang=js&"
export * from "./OutreachApproveforNicheView.vue?vue&type=script&lang=js&"
import style0 from "./OutreachApproveforNicheView.vue?vue&type=style&index=0&id=60b9db74&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports